import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { DateFormatConstants } from '../../constants';

@Injectable()
export class TimezoneDateProvider {
  /**
   * Gets a timezone adjusted pickup date string with the given format
   *
   * @param reservation
   * @param dateFormat
   */
  getFormattedTimeZoneDate(date: Date, timeZone: string, dateFormat = DateFormatConstants.DATE_FORMAT_FULL): string {
    return moment.tz(date, timeZone).format(dateFormat.replace('tz', '[' + timeZone + ']'));
  }
}
